import { Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { Modal } from '@abyss/web/ui/Modal';
import find from 'lodash/find';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { useLagoon } from '../../hooks/useLagoon';
import {
  guestScheduleModalInfoStyles,
  guestScheduleModalStyles,
} from './ScheduleModal.style';

type GuestScheduleModalProps = {
  isOpen: boolean;
  onSignIn: () => void;
  setIsOpen: (isOpen: boolean) => void;
};

export const GuestScheduleModal = ({
  isOpen,
  onSignIn,
  setIsOpen,
}: GuestScheduleModalProps) => {
  const data = useLagoon('ui-messaging')();
  const { t } = useTranslation();

  const guestStartModalTitle = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION
      .GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_TITLE,
  });
  const guestStartModalDescription = find(data, {
    key: ConstantsLagoon.GUEST_PLAN_SELECTION
      .GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_DESC,
  });

  return (
    <React.Fragment>
      <Modal
        css={guestScheduleModalStyles}
        data-testid="guest-schedule-modal"
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        title={guestStartModalTitle?.message}
      >
        <Modal.Section
          css={guestScheduleModalInfoStyles}
          data-testid="guest-schedule-modal-info"
        >
          {guestStartModalDescription?.message}
        </Modal.Section>
        <Modal.Section>
          <Layout.Group alignLayout="right">
            <Button
              data-testid="guest-close-button"
              onClick={() => setIsOpen(false)}
              variant="outline"
            >
              {t('GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_MODAL.CLOSE_BUTTON')}
            </Button>
            <Button
              data-testid="guest-sign-in-button"
              onClick={() => {
                onSignIn();
              }}
            >
              {t('GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_MODAL.SIGN_IN_BUTTON')}
            </Button>
          </Layout.Group>
        </Modal.Section>
      </Modal>
    </React.Fragment>
  );
};
